if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}




/* ============================= */
/* Right Sticker Footer Animation */
/* ============================= */

document.addEventListener("scroll", () => {
  const footer = document.querySelector(".footer");
  const stickers = document.querySelectorAll(".sticker");
  if (!footer || stickers.length === 0) return;

  const footerTop = footer.offsetTop;
  const footerHeight = footer.offsetHeight;
  const scrollY = window.scrollY;
  const windowH = window.innerHeight;

  const start = footerTop - windowH + 50; // when fall starts

//   if (scrollY >= start) {
//     // Control how far each sticker stops from footer bottom
//   let distanceFromBottom;

// if (window.innerWidth <= 768) {
//   // Mobile/tablet
//   distanceFromBottom = [80, 81]; // stickers stop lower on mobile
// }
// else {
//   // Desktop
//   distanceFromBottom = [120, 160]; // stickers stop higher on desktop
// }
if (scrollY >= start) {
let distanceFromBottom;

if (window.innerWidth >= 769 && window.innerWidth <= 1024) {
  // TABLET ONLY
  distanceFromBottom = [0, 1];
} 
else if (window.innerWidth <= 768) {
  // MOBILE ONLY
  distanceFromBottom = [80, 81]; 
} 
else {
  // DESKTOP
  distanceFromBottom = [120, 160];
}


    stickers.forEach((s, i) => {
      // Skip if already fallen
      if (s.dataset.fallen === "true") return;

      s.dataset.fallen = "true"; // mark as fallen
      s.style.opacity = 1;

      const stickerHeight = s.offsetHeight || 90;
      let finalY = footerHeight - stickerHeight - distanceFromBottom[i];
      if (finalY < 0) finalY = 0;

      const overshoot = 15;
      s.style.transform = `translateY(${finalY + overshoot}px)`;

      setTimeout(() => {
        s.style.transform = `translateY(${finalY}px)`;
      }, 500 + i * 100);
    });
  }
});


/* ============================= */
/* End Right Sticker Footer Animation */
/* ============================= */